import * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import type * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../../me'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Navigate to either Pages or Page Builder depending on whether a page entity
 * is being edited
 * NOTE: This logic should apply only when an entity is being edited,
 * not during creation.
 */
export const pageBuilderNavigation = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    pagesEc: Collection,
    meFeature: me.Feature,
    router: router.Router,
  ) =>
    pagesEc.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asObservable.pipe(
        rxjs.withLatestFrom(
          router.selectors.routeParams.asObservable,
          pagesEc.plugins.currentEntityPlugin.feature.selectors.isCreating()
            .asObservable,
        ),
        rxjs.switchMap(([editedEntity, routeParams, isCreating]) => {
          // Proceed with navigation only if:
          // 1. We are on Page list when entity is being edited
          // 2. We are on Page Builder when entity is not being edited
          const navigationId =
            editedEntity && !isCreating
              ? ents.extra.prebuilt.AppPageAlias.Pages
              : ents.extra.prebuilt.AppPageAlias.PageBuilder

          return routeParams.appPageAlias === navigationId
            ? meFeature.contexts.selectors
                .getUrlForLink({
                  goto: {
                    navigationId: editedEntity
                      ? ents.extra.prebuilt.AppPageAlias.PageBuilder
                      : ents.extra.prebuilt.AppPageAlias.Pages,
                  },
                })
                .asObservable.pipe(rxjs.take(1))
            : rxjs.of(undefined)
        }),
        rxjs.map(url =>
          url
            ? router.actions.navigate
                .from('pageBuilderNavigation (effect)')
                .create({ url })
            : store.effects.SKIP,
        ),
      ),
)
